import React, { type ReactNode } from 'react';
import classnames from 'classnames';

import { isMobileUA } from 'dpl/shared/utils';
import ToastNotificationsListItem from 'dpl/components/ToastNotificationsList/ToastNotificationsListItem';

import type { ToastNotificationType } from './ToastNotificationsListItem';

const isMobile = isMobileUA();

export type { ToastNotificationType };

export interface ToastNotification {
  id: number;
  message: ReactNode;
  type?: ToastNotificationType;
  showCloseButton?: boolean;
}

export interface ToastNotificationsListProps {
  toastNotifications: ToastNotification[];
  removeToastNotification: (toastNotification: ToastNotification) => void;
}

export default function ToastNotificationsList({
  toastNotifications,
  removeToastNotification
}: ToastNotificationsListProps) {
  if (toastNotifications.length === 0) {
    return null;
  }

  return (
    <div
      className={classnames('ToastNotificationsList mw-90 fixed z-max', {
        'bottom-1 left-1': isMobile,
        'bottom-2 left-2': !isMobile
      })}
    >
      <ul>
        {toastNotifications.map(tn => (
          <ToastNotificationsListItem
            key={tn.id}
            message={tn.message}
            type={tn.type}
            showCloseButton={tn.showCloseButton}
            onClose={() => removeToastNotification(tn)}
          />
        ))}
      </ul>
    </div>
  );
}
